"use client";
import { FilterPanel } from "@/components/FilterPanel";
import { FC, useContext } from "react";
import { Analytics, BuilderBlockProps } from "@/types";
import { IndexCardsContext } from "./IndexContextBlock";
import { CscInternalSearchContext } from "../InternalSearch/CscInternalSearchContextBlock";

type FilterPanelBlockProps = {
  filterVariant?: "index" | "search";
  alwaysDisplayed?: boolean;
  noResultsFoundText: string;
  resultsFoundText: string;
  singularResultFoundText: string;
  loadingText: string;
  clearAll: { text: string } & Analytics;
  withBottomLine?: boolean;
} & BuilderBlockProps;
export const FilterPanelBlock: FC<FilterPanelBlockProps> = ({
  filterVariant = "index",
  noResultsFoundText,
  resultsFoundText,
  singularResultFoundText,
  loadingText,
  clearAll,
  attributes,
  alwaysDisplayed,
  withBottomLine = false,
}) => {
  const indexContext = useContext(IndexCardsContext);
  const searchContext = useContext(CscInternalSearchContext);

  const context = filterVariant === "search" ? searchContext : indexContext;

  const {
    selectedFilters,
    isLoading,
    onFilter,
    numberOfResults,
    searchExpression,
  } = context;

  return alwaysDisplayed || selectedFilters.length || searchExpression ? (
    <FilterPanel
      noResultsFoundText={noResultsFoundText}
      resultsFoundText={resultsFoundText}
      singularResultFoundText={singularResultFoundText}
      numberOfResults={numberOfResults}
      loadingText={loadingText}
      isLoading={isLoading}
      clearAll={clearAll}
      selectedFilters={selectedFilters}
      onFilter={onFilter}
      withBottomLine={withBottomLine}
      showPillsFirst={filterVariant !== "search"}
      {...attributes}
    />
  ) : null;
};
